import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import urlHandler from '../../utils/urlHandler';
import validation from '../../utils/validation';
import data from '../../utils/data';
import ReactModal from 'react-modal';
import {Validators, FormBuilder, FieldControl, FieldGroup, FieldArray, FormArray} from 'react-reactive-form';
import renderers from './forms/renderers';
import ArrayEditControl from './forms/ArrayEditControl';
import LocationEditControl from './forms/LocationEditControl';
import StocksEditControl from './forms/StocksEditControl';
import LanguageFieldsEditControl from './forms/LanguageFieldsEditControl';
import PhoneNumbersEditControl from './forms/PhoneNumbersEditControl';
import EmailsEditControl from './forms/EmailsEditControl';
import IdentifiersEditControl from './forms/IdentifiersEditControl';
import LinkEditControlBase from './forms/LinkEditControlBase';

class UpdateProgress extends Component {
    render() {
        return (
            <span className="kbedit-updating">
                <span className="fa fa-circle-o-notch fa-spin"></span>&nbsp;Updating ...
            </span>
        );
    }
}

class KbEditOrganizationDialog extends Component {
    constructor(props){
        super(props);

        this.close = this.close.bind(this);
        this.open = this.open.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onReset = this.onReset.bind(this);
        this.onScrollTo = this.onScrollTo.bind(this);
        this.updateHeightDimensions = this.updateHeightDimensions.bind(this);

        this.state = {
            height: 0,
            modalOpen: false,
            error: null,
            updating: false,
            data: null
        };
    };

    componentDidMount() {
        ReactModal.setAppElement('#rm_KbEditOrganizationDialog');
        if (this.props.id) {
           this.updateHeightDimensions();
           this.open();
        } 
    }

    componentWillUnmount() {
        //window.removeEventListener('resize', this.updateHeightDimensions);
    }

    updateHeightDimensions() {
        this.setState({
            height: window.innerHeight - 75 - (window.innerHeight / 5)
        })
    }

    close(resp=null) {
        this.setState({
            modalOpen: false,
            updating: false,
            error: null
        }, () => {
            if (this.props.onClose) {
                this.props.onClose(resp);
            }
        })
    };

    open() {
        if (this.props.id) {
            urlHandler.sendRequest('entities2', null, this.props.id, null, null, (resp,txt,status) => {
                if (status == 200) {
                    this.myForm = FormBuilder.group({
                        label: [resp.label ? resp.label : '', Validators.required],
                        description: [resp.description ? resp.description : '', Validators.required],
                        subType: [resp.subType ? resp.subType : 'ORGANIZATION', Validators.required],
                        employeeCount: [resp.employeeCount ? resp.employeeCount : ''],
                        incorporationDate: [resp.incorporationDate ? resp.incorporationDate : '', Validators.pattern(validation.datePattern)],
                        inceptionDate: [resp.inceptionDate ? resp.inceptionDate : '', Validators.pattern(validation.datePattern)],
                        dateDissolved: [resp.dateDissolved ? resp.dateDissolved : '', Validators.pattern(validation.datePattern)],
                        nameVariations: FormBuilder.array(ArrayEditControl.initArray(resp.nameVariations), {validators: [Validators.required]}),
                        instanceOf: FormBuilder.array(ArrayEditControl.initArray(resp.instanceOf)),
                        phoneNumbers: FormBuilder.array(PhoneNumbersEditControl.initArray(resp.phoneNumbers)),
                        emails: FormBuilder.array(EmailsEditControl.initArray(resp.emails)),
                        employerIdNumbers: FormBuilder.array(ArrayEditControl.initArray(resp.employerIdNumbers)),
                        owners: FormBuilder.array(ArrayEditControl.initArray(resp.owners)),
                        genres: FormBuilder.array(ArrayEditControl.initArray(resp.genres)),
                        legalForms: FormBuilder.array(ArrayEditControl.initArray(resp.legalForms)),
                        industries: FormBuilder.array(ArrayEditControl.initArray(resp.industries)),
                        founders: FormBuilder.array(ArrayEditControl.initArray(resp.founders)),
                        politicalIdeologies: FormBuilder.array(ArrayEditControl.initArray(resp.politicalIdeologies)),
                        parentOrganizations: FormBuilder.array(ArrayEditControl.initArray(resp.parentOrganizations)),
                        chairPersons: FormBuilder.array(ArrayEditControl.initArray(resp.chairPersons)),
                        subsidiaries: FormBuilder.array(ArrayEditControl.initArray(resp.subsidiaries)),
                        chiefExecutiveOfficers: FormBuilder.array(ArrayEditControl.initArray(resp.chiefExecutiveOfficers)),
                        partOf: FormBuilder.array(ArrayEditControl.initArray(resp.partOf)),
                        location: FormBuilder.group(LocationEditControl.initLocation(resp.location)),
                        registeredAddress: FormBuilder.group(LocationEditControl.initLocation(resp.registeredAddress)),
                        products: FormBuilder.array(LinkEditControlBase.initArray(resp.products)),
                        stocks: FormBuilder.array(StocksEditControl.initArray(resp.stocks)),
                        urls: FormBuilder.array(ArrayEditControl.initArray(resp.urls, [Validators.pattern(validation.urlPattern)])),
                        imageUrls: FormBuilder.array(ArrayEditControl.initArray(resp.imageUrls, [Validators.pattern(validation.urlPattern)])),
                        categories: FormBuilder.array(ArrayEditControl.initArray(resp.categories)),
                        contextKeywords: FormBuilder.array(ArrayEditControl.initArray(resp.contextKeywords)),
                        languageFields: FormBuilder.array(LanguageFieldsEditControl.initArray(resp.languageFields)),
                        identifiers: FormBuilder.array(IdentifiersEditControl.initArray(resp.identifiers)),
                        userData: [resp.userData ? JSON.stringify(resp.userData) : ''],
                        prominence: [resp.prominence ? resp.prominence : 0.00],
                        document: [resp.document ? resp.document : '', [Validators.minLength(250)]]
                    });

                    this.setState({
                        data: resp,
                        modalOpen: true,
                        updating: false
                    })
                }
            });  
        } 
    };

    onSubmit(e) {
        e.preventDefault();
        this.setState({
            updating: true
        }, ()=> {
            if (this.myForm.valid) {

                var data = Object.assign({}, this.state.data);
                var formValues = Object.assign({}, this.myForm.getRawValue());

                // Merge any data that is missing from the form values into the form.
                Object.keys(data).forEach(function(key) {
                    if (!(key in formValues)) {
                        formValues[key] = data[key];
                    }
                });

                // Sync the URL values with ID values. User doesn't see the ID values, only edits the URL values.
                validation.syncIdsWithUrls(formValues);

                // Remove all empty fields from the update object
                validation.removeEmptyItems(formValues);

                // The range slider editor will return string values when touched by the user. Not sure why? Convert back to float.
                if ('prominence' in formValues) {
                    formValues.prominence = parseFloat(formValues.prominence);
                }

                // Validate the user data is JSON
                if ('userData' in formValues && formValues.userData.length > 0) {
                    try {
                        formValues.userData = JSON.parse(formValues.userData);
                    } catch(ex) {
                        var msg = '';
                        if (ex instanceof SyntaxError) {
                            msg = 'SyntaxError: ' + ex.message;
                        } else {
                            msg = ex.message;                           
                        }
                        this.setState({
                            error: 'Invalid user data JSON value.\n' + msg,
                            updating: false
                        }, () => {
                            this.onScrollTo('err_msg');
                        })
                        return;
                    }
                }

                urlHandler.sendKbUpdateRequest(this.props.id, formValues, (resp, status) => {
                    if (status != 200) {
                        let error = decodeURIComponent(resp.error_message)
                        error = (error === undefined || error === 'undefined') ? '' : error;
                        if (!error && status == 504) {
                            error ='FFT Gateway timed out. Contact your administrator. Please try again later.' 
                        }
                        else if(!error) {
                            error = 'There was an error updating the organization entity. Please try again later.';
                        }
                        this.setState({
                            error,
                            updating: false
                        }, () => {
                            this.onScrollTo('err_msg');
                        })   
                    } else {
                        this.close(resp);
                    }
                })
            } else {
                this.setState({
                    error: 'There are errors below.',
                    updating: false
                }, () => {
                    this.onScrollTo('err_msg');
                })
            }
        });
    }

    onReset() {
        this.close();
    }

    onScrollTo(anchor) {
        document.getElementById(anchor).scrollIntoView({block: 'start', behavior: 'smooth'});
    }

    render() {
        var subTypes = data.getOrgSubTypes();

        const styles = {
            overlay: {
                backgroundColor: 'rgba(0, 0, 0, 0.35)',
                overflow: 'hidden',
                height: '2000px',
                zIndex: '1000'
            },
            content : {
                top         : '0',
                left        : '50%',
                marginRight : '-50%',
                paddingTop  : '35px',
                paddingBottom: '5px',
                transform   : 'translate(-50%)',
                maxWidth    : '70%',
                height      : '100%',
                padding     : '0px',
                opacity     : '0.99',
                border      : '0px',
                background  : 'transparent',
                borderRadius: '0px 0px 5px 5px'
            }
        }

        return (
           <div id="rm_KbEditOrganizationDialog">
                <ReactModal ref="editId" 
                    isOpen={this.state.modalOpen}
                    contentLabel={this.props.name}
                    onRequestClose={this.close} 
                    style={styles}
                    shouldCloseOnOverlayClick={false}
                    closeTimeoutMS={1000}>
                    <div className="kbedit">
                        <div className="kbedit-header">
                            <span className="header-text">Edit {this.props.name}</span>
                        </div> 

                        <div className="kbedit-content" style={{maxHeight: `${this.state.height}px`}}>

                        <div className="kbedit-controls-wrapper">
                            <div className="kbedit-static-menu">
                                <span onClick={() => {this.onScrollTo('bm_organization_details')}}>Organization Details</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_instance_of')}}>Instance Of</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_identifiers')}}>Identifiers</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_phone_numbers')}}>Phone Numbers</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_emails')}}>Emails</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_owners')}}>Owners</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_genres')}}>Genres</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_legal_forms')}}>Legal Forms</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_industries')}}>Industries</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_founders')}}>Founders</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_political_ideologies')}}>Political Ideologies</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_parent_organizations')}}>Parent Organizations</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_chair_persons')}}>Chair Persons</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_subsidiaries')}}>Subsidaries</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_ceos')}}>Chief Executive Officers</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_part_of')}}>Part Of</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_location')}}>Location</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_registered_address')}}>Registered Address</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_products')}}>Products</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_stocks')}}>Stocks</span><br/>             
                                <span onClick={() => {this.onScrollTo('bm_urls')}}>Urls</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_image_urls')}}>Image Urls</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_categories')}}>Categories</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_context_keywords')}}>Context Keywords</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_language_fields')}}>Language Fields</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_user_data')}}>User Data</span><br/>
                                <span onClick={() => {this.onScrollTo('bm_document')}}>Document</span>
                            </div>

                            <div className="kbedit-controls-list">
                                {this.state.error &&
                                    <div className="kbedit-error" id="err_msg">
                                        {this.state.error}
                                    </div>
                                }

                                <FieldGroup
                                    control={this.myForm}
                                    render={({ pristine, value, invalid}) => (
                                        <div className="kbedit-nav-items">
                                            <div id="bm_organization_details">
                                                <FieldControl name='label' render={renderers.textBox} meta={{label: 'Label', placeholder: 'Enter name'}}/>
                                                <FieldControl name='description' render={renderers.textArea} 
                                                    meta={{
                                                        label: 'Description', 
                                                        placeholder: 'Enter description',
                                                        height: '300px'
                                                    }}
                                                />
                                                <FieldControl name='prominence' render={renderers.rangeSlider} meta={{label: 'News Prominence'}}/>
                                                <FieldControl name='subType' render={renderers.selectBox} meta={{label: 'Sub Type', items: subTypes}}/>
                                                <FieldControl name='employeeCount' render={renderers.numberBox} meta={{label: 'Employee Count'}}/>
                                                <FieldControl name='incorporationDate' render={renderers.textBox} meta={{label: 'Incorporation Date', placeholder: 'YYYY-MM-DD'}}/>
                                                <FieldControl name='inceptionDate' render={renderers.textBox} meta={{label: 'Inception Date', placeholder: 'YYYY-MM-DD'}}/>
                                                <FieldControl name='dateDissolved' render={renderers.textBox} meta={{label: 'Date Dissolved', placeholder: 'YYYY-MM-DD'}}/>
                                                <ArrayEditControl name='nameVariations' label='Name Variations' addLabel="Add name variation" form={this.myForm}/>
                                                <ArrayEditControl name='employerIdNumbers' label='Employer Id Numbers' addLabel="Add employer id" form={this.myForm}/>                                                                                                                
                                            </div>
                                            <div id="bm_instance_of">
                                                <ArrayEditControl name='instanceOf' label='Instance Of' addLabel="Add instance" form={this.myForm}/>
                                            </div>
                                            <div id="bm_identifiers">
                                                <IdentifiersEditControl name='identifiers' label='Identifiers' addLabel="Add identifier" form={this.myForm}/>
                                            </div>
                                            <div id="bm_phone_numbers">
                                                <PhoneNumbersEditControl name='phoneNumbers' label='Phone Numbers' addLabel="Add phone" form={this.myForm}/>
                                            </div>
                                            <div id="bm_emails">
                                                <EmailsEditControl name='emails' label='Emails' addLabel="Add email" form={this.myForm} type="ORGANIZATION"/>
                                            </div>
                                            <div id="bm_owners">
                                                <ArrayEditControl name='owners' label='Owners' addLabel="Add owner" form={this.myForm}/>
                                            </div>
                                            <div id="bm_genres">
                                                <ArrayEditControl name='genres' label='Genres' addLabel="Add genre" form={this.myForm}/>
                                            </div>
                                            <div id="bm_legal_forms">
                                                <ArrayEditControl name='legalForms' label='Legal Forms' addLabel="Add legal form" form={this.myForm}/>
                                            </div>
                                            <div id="bm_industries">
                                                <ArrayEditControl name='industries' label='Industries' addLabel="Add industry" form={this.myForm}/>
                                            </div>
                                            <div id="bm_products">
                                                <LinkEditControlBase name="products" label="Products" addLabel="Add Product" form={this.myForm}/>
                                            </div>
                                            <div id="bm_founders">
                                                <ArrayEditControl name='founders' label='Founders' addLabel="Add founder" form={this.myForm}/>
                                            </div>
                                            <div id="bm_political_ideologies">
                                                <ArrayEditControl name='politicalIdeologies' label='Political Ideologies' addLabel="Add ideology" form={this.myForm}/>
                                            </div>
                                            <div id="bm_parent_organizations">
                                                <ArrayEditControl name='parentOrganizations' label='Parent Organizations' addLabel="Add organization" form={this.myForm}/>
                                            </div>
                                            <div id="bm_chair_persons">
                                                <ArrayEditControl name='chairPersons' label='Chair Persons' addLabel="Add chair person" form={this.myForm}/>
                                            </div>
                                            <div id="bm_subsidiaries">
                                                <ArrayEditControl name='subsidiaries' label='Subsidiaries' addLabel="Add subsidary" form={this.myForm}/>
                                            </div>
                                            <div id="bm_ceos">
                                                <ArrayEditControl name='chiefExecutiveOfficers' label='Chief Executive Officers' addLabel="Add ceo" form={this.myForm}/>
                                            </div>
                                            <div id="bm_part_of">
                                                <ArrayEditControl name='partOf' label='Part Of' addLabel="Add part of" form={this.myForm}/>
                                            </div>
                                            <div id="bm_location">
                                                <LocationEditControl name="location" label="Location" form={this.myForm}/>
                                            </div>
                                            <div id="bm_registered_address">
                                                <LocationEditControl name="registeredAddress" label="Registered Address" form={this.myForm}/>
                                            </div>
                                            <div id="bm_stocks">
                                                <StocksEditControl name="stocks" label="Stocks" addLabel="Add stock" form={this.myForm}/>
                                            </div>
                                            <div id="bm_urls">
                                                <ArrayEditControl name='urls' label='Urls' addLabel="Add url" form={this.myForm} itemValidators={[Validators.pattern(validation.urlPattern)]}/>
                                            </div>
                                            <div id="bm_image_urls">
                                                <ArrayEditControl name='imageUrls' 
                                                    label='Image Urls' 
                                                    addLabel="Add image url" 
                                                    form={this.myForm} 
                                                    itemValidators={[Validators.pattern(validation.urlPattern)]}
                                                    image={true}
                                                />
                                            </div>
                                            <div id="bm_categories">
                                                <ArrayEditControl name='categories' label='Categories' addLabel="Add category" form={this.myForm}/>
                                            </div>
                                            <div id="bm_context_keywords">
                                                <ArrayEditControl name='contextKeywords' label='Context Keywords' addLabel="Add keyword" form={this.myForm} expanded={false}/>
                                            </div>
                                            <div id="bm_language_fields">
                                                <LanguageFieldsEditControl name="languageFields" label="Language Fields" addLabel="Add language field" form={this.myForm}/>
                                            </div>
                                            <div id="bm_user_data">
                                                <FieldControl name='userData' render={renderers.textArea} 
                                                    meta={{
                                                        label: 'User Data (Valid JSON)', 
                                                        placeholder: 'Enter JSON',
                                                        height: '300px',
                                                        monospace: true,
                                                        expanded: false
                                                    }}
                                                />
                                            </div>
                                            <div id="bm_document">
                                                <FieldControl name='document' render={renderers.textArea} 
                                                    meta={{
                                                        label: 'Document', 
                                                        placeholder: 'Enter document',
                                                        height: '500px'
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                />
                            </div>
                        </div>
                        
                        </div>
                        <div className="kbedit-footer">
                            {this.state.updating ? <UpdateProgress /> : null}
                            <button type="button" className="kbedit-default-button" onClick={this.onSubmit}>Save</button>
                            <button type="button" className="kbedit-default-button" onClick={this.onReset}>Cancel</button>
                        </div>
                    </div>
                </ReactModal>
            </div>
        );
    };
}

KbEditOrganizationDialog.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onClose: PropTypes.func
};

export default KbEditOrganizationDialog;

export function kbEditOrganizationDialog(name, id, callback) {
    
    var divTarget = document.getElementById('react-kbeditorganization-dialog')

    var close = (ans) => {
        if (divTarget) {
            ReactDOM.unmountComponentAtNode(divTarget);
        }
        if (callback) {
            callback(ans);
        }
    }

    if (divTarget) {
        ReactDOM.render(<KbEditOrganizationDialog name={name} id={id} onClose={close}/>, divTarget);
    } else {
        divTarget = document.createElement('div')
        divTarget.id = 'react-kbeditorganization-dialog'
        document.body.appendChild(divTarget)
        ReactDOM.render(<KbEditOrganizationDialog name={name} id={id} onClose={close}/>, divTarget);
    }
 }

